import { Reveal } from "./Reveal";

export default function PageHero({ eyebrow, title, lead, image, imageAlt = "" }) {
  return (
    <section className="grain relative overflow-hidden bg-brand-obsidian pb-16 pt-[104px] sm:pb-20 sm:pt-28 lg:pb-24">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-40 -top-40 h-[480px] w-[480px] rounded-full opacity-30"
        style={{ background: "radial-gradient(circle, rgba(254,115,13,0.45) 0%, transparent 65%)" }}
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -left-40 bottom-0 h-72 w-72 rounded-full opacity-20"
        style={{ background: "radial-gradient(circle, rgba(255,183,0,0.5) 0%, transparent 65%)" }}
      />
      <div
        className={`mx-auto max-w-8xl px-4 sm:px-6 lg:px-8 ${image ? "grid items-center gap-10 lg:grid-cols-[1.1fr_0.9fr]" : ""}`}
      >
        <div>
          <Reveal>
            <p className="font-mono text-xs font-semibold uppercase tracking-[0.3em] text-brand-orange">
              {eyebrow}
            </p>
          </Reveal>
          <Reveal delay={0.08}>
            <h1
              data-testid="page-hero-title"
              className="mt-4 max-w-2xl font-display text-3xl font-extrabold leading-[1.08] tracking-tight text-white sm:text-4xl lg:text-[3.4rem]"
            >
              {title}
            </h1>
          </Reveal>
          {lead && (
            <Reveal delay={0.16}>
              <p className="mt-5 max-w-2xl text-base leading-relaxed text-slate-300 sm:text-lg">{lead}</p>
            </Reveal>
          )}
        </div>
        {image && (
          <Reveal delay={0.2} className="hidden lg:block">
            <div className="relative overflow-hidden rounded-3xl border border-white/10 shadow-2xl">
              <img
                src={image}
                alt={imageAlt}
                loading="lazy"
                className="aspect-[4/3] w-full object-cover"
              />
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-brand-obsidian/60 via-transparent to-transparent" />
            </div>
          </Reveal>
        )}
      </div>
    </section>
  );
}
